export default function (value) {
  if (value > 1) return 'events';
  return 'event';
}
